export default function getSiteCreateDataCentersReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'GET_SITE_CREATE_DATA_CENTERS_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'GET_SITE_CREATE_DATA_CENTERS_ERROR':
            return {...state, ...{ error: action.error }};

        case 'GET_SITE_CREATE_DATA_CENTERS_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}